import { render, staticRenderFns } from "./not-enough-credits-to-upload-modal.vue?vue&type=template&id=6018bc82"
import script from "./not-enough-credits-to-upload-modal.vue?vue&type=script&lang=js"
export * from "./not-enough-credits-to-upload-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports